import NextLink from 'next/link'
import { type AnchorHTMLAttributes, type ReactNode } from 'react'

type SimpleLinkProps = {
  href: string
  className?: string
  children?: ReactNode
} & Pick<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  | 'id'
  | 'rel'
  | 'role'
  | 'tabIndex'
  | 'target'
  | 'onClick'
  | 'onBeforeInput'
  | 'style'
>

const SimpleLink = ({
  id,
  rel,
  role = 'link',
  href,
  tabIndex,
  target,
  onClick,
  onBeforeInput,
  className,
  style,
  children,
}: SimpleLinkProps) => {
  if (!href) {
    return null
  }

  return (
    <NextLink
      id={id}
      href={href}
      tabIndex={tabIndex}
      target={target}
      rel={rel}
      role={role}
      onClick={onClick}
      onBeforeInput={onBeforeInput}
      className={className}
      style={style}
    >
      {children}
    </NextLink>
  )
}

export default SimpleLink
